import { render, staticRenderFns } from "./decline.vue?vue&type=template&id=6890a165"
import script from "./decline.vue?vue&type=script&lang=js"
export * from "./decline.vue?vue&type=script&lang=js"
import style0 from "./decline.vue?vue&type=style&index=0&id=6890a165&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports